import { authToken, teladocApi } from '@td/api';

const benefitStatusManager = (mrnId, strategy, teamSupportTicket) => {
  const request = {
    mrn_id: mrnId,
    strategy: strategy,
    team_support_ticket: teamSupportTicket
  }
  return teladocApi.put('/v4/benefit_management/benefit_status_manager', request, authToken.get());
};

export default benefitStatusManager;
